export default "__VITE_ASSET__CNnpxsmY__"